import type { Note } from './types/index'

tag notes-list-item
	css
		div
			cursor:pointer
			d:flex
			fld: column
			min-height:4rem
			ls:1px
			p:4
			tween:all .3s ease

			&.selected
				bdl: 5px solid red6
				bg:gray1
		
		p fw:thin pe:none
		
		.title
			fs:1.1rem
			mb:0
		.date
			c:gray5
			fs:.8rem
	
	prop note\Note

	def handleSelectNote e\CustomEvent
		emit('selectNote', note)

	<self> 
		<div @click.stop=handleSelectNote .selected=note.selected> 
			<p .title> note.title
			<p .date> note.date


